var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMinitwitterlogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14181",
    "data-name": "Group 14181",
    transform: "translate(-1231 -3935)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_42",
    "data-name": "Ellipse 42",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(1231 3935)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "twitter",
    transform: "translate(1238.884 3943.419)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M16.033,1.61a6.351,6.351,0,0,1-1.889.541,3.428,3.428,0,0,0,1.446-1.9,6.462,6.462,0,0,1-2.09.834A3.216,3.216,0,0,0,11.1,0,3.365,3.365,0,0,0,7.811,3.435a3.592,3.592,0,0,0,.085.783A9.212,9.212,0,0,1,1.117.628,3.527,3.527,0,0,0,.672,2.355,3.477,3.477,0,0,0,2.135,5.214a3.183,3.183,0,0,1-1.49-.431v.043A3.405,3.405,0,0,0,3.283,8.195a3.2,3.2,0,0,1-.867.12A3.027,3.027,0,0,1,1.8,8.251a3.313,3.313,0,0,0,3.072,2.386A6.422,6.422,0,0,1,.784,12.106,6.7,6.7,0,0,1,0,12.059,9.012,9.012,0,0,0,5.042,13.6c6.05,0,9.358-5.235,9.358-9.775l-.011-.445A6.736,6.736,0,0,0,16.033,1.61Z",
    transform: "translate(0 0)",
    fill: "#55acee"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinitwitterlogo);
export default __webpack_public_path__ + "static/media/minitwitterlogo.e08ea7b70f98dc08477fdcf0598629f5.svg";
export { ForwardRef as ReactComponent };